import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { postReq } from "../../configs/ApiUrl";
import { useTranslation } from "react-i18next";
import AlwaysTop from "./util/AlwaysTop";
import Button from "../Button";

function WelcomeSignup() {
  const { t } = useTranslation(["forms", "altText"]);
  const navigateLogin = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [preferredLanguage, setPreferredLanguage] = useState("sv");

  let nameInputColor = "bg-white";
  let emailInputColor = "bg-white";
  let passwordInputColor = "bg-white";
  let passwordConfirmInputColor = "bg-white";

  let passwordAlert = "";
  let colorAlert = "text-black";

  let termAlert = "";

  let emailAlert = "";

  let lengthAlert = "";

  const [nameState, setNameState] = useState({
    nameBackground: nameInputColor,
    nameHolder: t("usernamePlace"),
  });

  const [emailState, setEmailState] = useState({
    emailBackground: emailInputColor,
    emailHolder: t("emailLabel"),
  });

  const [passwordState, setPasswordState] = useState({
    passwordBackground: passwordInputColor,
    passwordHolder: t("passwordLabel"),
  });

  const [passwordConfirmState, setPasswordConfirmState] = useState({
    passwordConfirmBackground: passwordConfirmInputColor,
    passwordConfirmHolder: t("passwordConfirm"),
  });

  const [termState, setTermState] = useState({
    termText: termAlert,
  });

  const [passwordMatchState, setPasswordMatchState] = useState({
    passwordMatchText: passwordAlert,
    passwordMatchColor: colorAlert,
  });

  const [emailConfirmState, setEmailConfirmState] = useState({
    emailConfirmText: emailAlert,
  });

  const [passwordLengthState, setPasswordLengthState] = useState({
    lengthText: lengthAlert,
  });

  useEffect(() => {
    setNameState({
      nameBackground: "bg-white",
      nameHolder: t("usernamePlace"),
    });

    setEmailState({
      emailBackground: "bg-white",
      emailHolder: t("emailLabel"),
    });

    setPasswordState({
      passwordBackground: "bg-white",
      passwordHolder: t("passwordLabel"),
    });

    setPasswordConfirmState({
      passwordConfirmBackground: "bg-white",
      passwordConfirmHolder: t("passwordConfirm"),
    });
  }, [t]);

  useEffect(() => {
    AlwaysTop();
  }, []);

  return (
    <div className='flex flex-col items-center min-h-screen'>
      <div className='w-full max-w-md px-6'>
        <div className='flex items-center pt-10 mb-6'>
          <img
            alt={t("altText:verticalDivider")}
            src='./../assets/icons/divider-vertical.svg'
            className='h-10 mr-4'
          />
          <h1 className='text-3xl font-bold'>{t("signUp")}</h1>
        </div>
        <form
          className='w-full'
          onSubmit={async (e) => {
            e.preventDefault();
            try {
              let name = e.target.name.value;
              let email = e.target.email.value;
              let password = e.target.password.value;
              let passwordConfirm = e.target.passwordConfirm.value;
              let termsConditions = e.target.terms.checked;

              let userData = {
                username: name,
                email,
                password,
                termsConditions,
                preferredLanguage, // Include preferred language in the submission
              };

              let emailCheck = email.search(/@/);
              let passwordLength = password.length;

              setIsLoading(true);

              if (
                name === "" ||
                email === "" ||
                password === "" ||
                passwordConfirm === "" ||
                termsConditions === false ||
                emailCheck === -1
              ) {
                if (name === "") {
                  setIsLoading(false);
                  setNameState({
                    ...nameState,
                    nameBackground: "bg-red-200",
                    nameHolder: t("invalidUsername"),
                  });
                }

                if (email === "") {
                  setIsLoading(false);
                  setEmailState({
                    ...emailState,
                    emailBackground: "bg-red-200",
                    emailHolder: t("invalidEmail"),
                  });
                }

                if (password === "") {
                  setIsLoading(false);
                  setPasswordState({
                    ...passwordState,
                    passwordBackground: "bg-red-200",
                    passwordHolder: t("passwordPlace"),
                  });
                }

                if (passwordConfirm === "") {
                  setIsLoading(false);
                  setPasswordConfirmState({
                    ...passwordConfirmState,
                    passwordConfirmBackground: "bg-red-200",
                    passwordConfirmHolder: t("passwordConfirm"),
                  });
                }

                if (termsConditions === false) {
                  setIsLoading(false);
                  setTermState({
                    ...termState,
                    termText: t("invalidTerms"),
                  });
                }

                if (emailCheck === -1 && email !== "") {
                  setIsLoading(false);
                  setEmailConfirmState({
                    ...emailConfirmState,
                    emailConfirmText: t("invalidEmail"),
                  });
                }

                return;
              }

              if (password !== passwordConfirm) {
                setIsLoading(false);
                setPasswordMatchState({
                  ...passwordMatchState,
                  passwordMatchText: t("passwordMismatch"),
                  passwordMatchColor: "text-red-500",
                });

                return;
              }

              if (passwordLength < 8 || passwordLength > 20) {
                setIsLoading(false);
                setPasswordLengthState({
                  ...passwordLengthState,
                  lengthText: t("passwordPlace"),
                });

                return;
              }

              const signupResponse = await postReq("/user/register", userData);
              console.log("Signup response:", signupResponse);
              setIsLoading(false);

              if (signupResponse?.user?.id) {
                navigateLogin("/signup-confirmation");
              }
            } catch (error) {
              setIsLoading(false);
              console.error("Internal server error at signup:", error);
            }
          }}>
          <div className='w-full mb-6'>
            <label
              className='text-zinc-400 font-semibold'
              htmlFor='name'>
              {t("usernameLabel")}
            </label>
            <input
              name='name'
              className={`${nameState.nameBackground} form-field w-full px-4 py-2`}
              placeholder={nameState.nameHolder}
              onClick={() => {
                setNameState({
                  ...nameState,
                  nameBackground: "bg-white",
                  nameHolder: t("usernamePlace"),
                });
              }}
            />
          </div>

          <div className='w-full mb-6'>
            <label
              className='text-zinc-400 font-semibold'
              htmlFor='email'>
              {t("emailLabel")}
            </label>
            <h2 className='text-red-500 font-semibold pl-2 lg:flex-row text-sm lg:text-base'>
              {emailConfirmState.emailConfirmText}
            </h2>
            <input
              name='email'
              className={`${emailState.emailBackground} form-field w-full px-4 py-2`}
              placeholder={emailState.emailHolder}
              onClick={() => {
                setEmailState({
                  ...emailState,
                  emailBackground: "bg-white",
                  emailHolder: t("emailPlace"),
                });
                setEmailConfirmState({
                  ...emailConfirmState,
                  emailConfirmText: "",
                });
              }}
            />
          </div>

          <div className='w-full mb-6'>
            <label
              className='text-zinc-400 font-semibold'
              htmlFor='password'>
              {t("createPassword")}
            </label>
            <h2 className='text-red-500 font-semibold pl-2 lg:flex-row text-sm lg:text-base'>
              {passwordMatchState.passwordMatchText}
            </h2>
            <input
              type='password'
              name='password'
              className={`${passwordState.passwordBackground} form-field w-full px-4 py-2`}
              placeholder={passwordState.passwordHolder}
              onClick={() => {
                setPasswordState({
                  ...passwordState,
                  passwordBackground: "bg-white",
                  passwordHolder: t("passwordPlace"),
                });
                setPasswordMatchState({
                  ...passwordMatchState,
                  passwordMatchText: "",
                  passwordMatchColor: "text-black",
                });
                setPasswordLengthState({
                  ...passwordLengthState,
                  lengthText: "",
                });
              }}
            />
          </div>

          <div className='w-full mb-6'>
            <label
              className='text-zinc-400 font-semibold'
              htmlFor='passwordConfirm'>
              {t("passwordConfirm")}
            </label>
            <input
              type='password'
              name='passwordConfirm'
              className={`${passwordConfirmState.passwordConfirmBackground} form-field w-full px-4 py-2`}
              placeholder={passwordConfirmState.passwordConfirmHolder}
              onClick={() => {
                setPasswordConfirmState({
                  ...passwordConfirmState,
                  passwordConfirmBackground: "bg-white",
                  passwordConfirmHolder: t("passwordConfirm"),
                });
                setPasswordMatchState({
                  ...passwordMatchState,
                  passwordMatchText: "",
                  passwordMatchColor: "text-black",
                });
                setPasswordLengthState({
                  ...passwordLengthState,
                  lengthText: "",
                });
              }}
            />
          </div>

          <div className='w-full mb-6'>
            <label
              className='text-zinc-400 font-semibold'
              htmlFor='languageSelect'>
              {t("forms:langPref")}
            </label>
            <select
              id='languageSelect'
              value={preferredLanguage}
              onChange={(e) => setPreferredLanguage(e.target.value)}
              className='form-field w-full px-4 py-2 border rounded'>
              <option value='en'>English</option>
              <option value='sv'>Swedish</option>
            </select>
          </div>

          <div className='w-full mb-6'>
            <input
              name='terms'
              type='checkbox'
              onClick={() => {
                setTermState({
                  ...termState,
                  termText: "",
                });
              }}
              className='mb-1 hover:cursor-pointer'
            />
            <label className='pl-2'>
              {t("termsConfirm")}
              <a
                href='https://24mobler.se/en/kopvillkor/'
                target='_blank'
                className='text-cromboOrange font-semibold hover:cursor-pointer hover:underline inline-flex items-center'>
                Terms & Conditions{" "}
                <img
                  src='./../assets/icons/new-window-icon.png'
                  width={16}
                  className='mb-2'
                  alt={t("altText:newTab")}
                />
              </a>
            </label>
            <p className='text-red-500 font-semibold'>{termState.termText}</p>
          </div>

          <div className='w-full flex justify-center mb-12'>
            <Button
              type='submit'
              variant='main'
              size='lg'
              disabled={isLoading}
              className={isLoading ? "opacity-50 cursor-not-allowed" : ""}>
              {isLoading ? "Loading..." : t("signUp")}
            </Button>
          </div>
        </form>
      </div>
      <h2 className='mx-auto text-lg'>
        {t("loginPrompt")}
        <Link
          to='/welcome-login'
          className='text-cromboOrange pl-1 font-bold hover:cursor-pointer hover:underline'>
          {t("login")}
        </Link>
      </h2>
    </div>
  );
}

export default WelcomeSignup;
